import * as React from "react";
import {STATUS_BUILT, STATUS_CANCELED, STATUS_CLAIMED, STATUS_DELIVERED, STATUS_DELIVERING, STATUS_QUEUED} from "./model/data";
import {inventoryFromMaterialsMap, numberWithCommas, parseNumber, renderShortDate, stripCorpTag} from "./util";

import {database, globalSettings} from "./config";
import {modifyBalance, PANDA_THEN_ISK} from "./model/transaction";
import {GlobalInfo} from "./context";
import {Card, Dropdown, DropdownButton, Nav} from "react-bootstrap";
import {LinkContainer} from "react-router-bootstrap";
import {Redirect, Route, Switch} from "react-router-dom";
import {toast} from "react-toastify";
import {FinanceOnly, If, MaterialList, Toggle} from "./Common";
import * as firebase from "firebase/app";
import {ACCOUNTS, saveAuditLog} from "./model/audit";
import {postToDiscord} from "./discord";
import {withTranslation} from "react-i18next";

class QueuePage extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      numPermanent: parseInt(localStorage.getItem("numPermanent")) || 5,
      specialWeight: parseInt(localStorage.getItem("specialWeight")) || 100,
      location: globalSettings.defaultLocationShipOrders,
    };
  }

  setLocation(e) {
    this.setState({
      location: e.target.value
    });
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    localStorage.setItem("numPermanent", this.state.numPermanent);
    localStorage.setItem("specialWeight", this.state.specialWeight);
  }

  claim(queue) {
    database.collection("queue").doc(queue.id).update({
      status: STATUS_CLAIMED,
      claimed_name: this.context.userData.name,
    })
  }

  unclaim(queue) {
    database.collection("queue").doc(queue.id).update({
      status: STATUS_QUEUED,
      claimed_name: '',
    })
  }

  deliver(queue, shouldBill) {
    // TODO: this should be a real transaction
    let cb = (ret) => {
      database.collection("queue").doc(queue.id).update({
        status: STATUS_DELIVERING,
        claimed_name: this.context.userData.name,
      });
      postToDiscord({
        channel: 'MANUFACTURE',
        content: `${this.context.userInfo.name} started delivery of a ${queue.name} order by <@${queue.actorInfo.id}>. Please accept the contract ASAP to free contract slots.`
      });
      if (shouldBill) {
        toast.success(`${queue.actorInfo.name} billed ${numberWithCommas(queue.price)} ISK. Their balance is now ${numberWithCommas(ret.newBalanceIsk)} ISK.`);
        if(ret.newBalanceIsk < -10 && !(queue.actorInfo.roles && queue.actorInfo.roles.superuser)) {
          postToDiscord({
            channel: 'MANUFACTURE',
            content: `<@${queue.actorInfo.id}>, your balance is now ${numberWithCommas(ret.newBalanceIsk)} ISK. Please make a deposit to the corp wallet and post a screenshot here.`
          })
        }
      }
    };
    if (shouldBill) {
      modifyBalance(this.context.userInfo, queue.actorInfo.id, ACCOUNTS.CORP_SHIP_SALE, PANDA_THEN_ISK, queue.price).then(cb)
    } else {
      cb()
    }
  }

  complete(queue) {
    database.collection("queue").doc(queue.id).update({
      status: STATUS_DELIVERED,
    })
  }

  cancel(queue) {
    database.collection("queue").doc(queue.id).update({
      status: STATUS_CANCELED
    })
  }

  build(queue) {
    const { t } = this.props;
    if (!this.state.location) {
      toast.error(t('pages:queue.errors.selectLocation'));
      return;
    }
    database.runTransaction((transaction) => {
      let p = [];
      let userRef = database.collection("users").doc(this.context.userData.id);
      let queueRef = database.collection("queue").doc(queue.id);
      let userData;
      let totalMaterialValue = 0;
      p.push(transaction.get(userRef).then(doc => {
        userData = doc.data();
      }));
      for (let [name, amount] of Object.entries(queue.materials)) {
        let materialRef = database.collection("materials").doc(name);
        p.push(transaction.get(materialRef).then((doc) => {
          let needed = queue.materials[name];
          transaction.update(materialRef, {
            totalInventory: firebase.firestore.FieldValue.increment(-needed),
            [`inventory.${this.state.location}`]: firebase.firestore.FieldValue.increment(-needed),
          });
          totalMaterialValue += needed * doc.data().price
        }));
      }
      return Promise.all(p).then(() => {
        let recipe = this.context.recipeMap[queue.name];
        let engineerPayment = totalMaterialValue * globalSettings.engineerPaymentMaterialCostRatio;
        let engineerCompensation = (queue.isk || recipe.isk) / 0.92 * 0; // Set to *0 as all builds are currently done in corp
        let blueprintPrice = recipe ? recipe.blueprint_price : 0;
        return Promise.all([
          transaction.update(queueRef, {
            status: queue.queue === "permanent" ? STATUS_QUEUED : STATUS_BUILT,
            claimed_name: this.context.userData.name,
          }),
          transaction.update(userRef, {
            balanceIsk: firebase.firestore.FieldValue.increment(engineerPayment + engineerCompensation),
            totalIsk: firebase.firestore.FieldValue.increment(engineerPayment),
          }),
          saveAuditLog(transaction, this.context.userInfo, this.context.userInfo, {
            [ACCOUNTS.CORP_PAYMENT_ENGINEER]: -engineerPayment,
            [ACCOUNTS.CORP_COST_BUILD]: -engineerCompensation,
            [ACCOUNTS.CORP_COST_BLUEPRINT]: -(blueprintPrice),
            [ACCOUNTS.CORP_INVENTORY]: -totalMaterialValue,
            [ACCOUNTS.CORP_INVENTORY_SHIP]: +queue.price,
            "corp.profit.build": queue.price - totalMaterialValue - engineerPayment - engineerCompensation - blueprintPrice
          }, {'queue': queue.id})
        ]).then(() => {
          toast.success(<div>
            {t('pages:queue.messages.buildLogged')}
            <ul>
              <li>+{numberWithCommas(engineerPayment)} ISK {t('pages:queue.messages.payment')}</li>
              <li>+{numberWithCommas(engineerCompensation)} ISK {t('pages:queue.messages.manufactureCost')}</li>
            </ul>
          </div>);
        })
      })
    })
  }

  toTop(queue) {
    database.collection("queue").doc(queue.id).update({
      timestamp: this.context.queue[0].timestamp - 1,
    })
  }

  toBottom(queue) {
    database.collection("queue").doc(queue.id).update({
      timestamp: +(new Date())
    })
  }

  toMain(queue) {
    database.collection("queue").doc(queue.id).update({
      queue: "main"
    })
  }

  toSpecial(queue) {
    database.collection("queue").doc(queue.id).update({
      queue: "special"
    })
  }

  setNote(queue) {
    const { t } = this.props;
    let newNote = prompt(t('pages:queue.prompts.newNote'));
    if(!newNote) {
      toast.error(t('common:messages.canceled'));
      return
    }
    database.collection("queue").doc(queue.id).update({
      notes: newNote
    }).then(() => {
      toast.success(t('pages:queue.messages.updated'))
    })
  }

  setPrice(queue) {
    const { t } = this.props;
    let newPrice = prompt(t('pages:queue.prompts.newPrice'));
    if(!newPrice) {
      toast.error(t('common:messages.canceled'));
      return
    }
    newPrice = parseNumber(newPrice);
    database.collection("queue").doc(queue.id).update({
      price: newPrice
    }).then(() => {
      toast.success(t('pages:queue.messages.updated'))
    })
  }

  updateRequests(materials, canDecrease) {
    const { t } = this.props;
    Object.keys(materials).forEach(name => {
      let amt = materials[name] + (this.context.materialsMap[name].totalBuffer || 0);
      if (!isNaN(amt)) {
        if (amt > this.context.materialsMap[name].totalTargetInventory || canDecrease) {
          database.collection("materials").doc(name).update({
            totalTargetInventory: Math.max(0, parseInt(amt))
          })
        }
      }
    });
    toast.success(t('pages:queue.messages.requestsUpdated'))
  }

  renderQueueRow = (queue, inventory, weight, totalMaterials, myClaimedMaterials) => {
    const { t } = this.props;

    if (queue.status == STATUS_BUILT || queue.status == STATUS_DELIVERING) {
      weight = 0;
    }

    let missingMaterials = Object.assign({}, queue.materials);
    let ready = true;
    let quantity = (queue.quantity) || 1;
    Object.keys(missingMaterials).forEach(name => {
      // skip material calculation if not at location
      if (this.state.location != "" && queue.location != this.state.location) {
        return
      }
      let needed = queue.materials[name] * weight;
      totalMaterials[name] = (totalMaterials[name] || 0) + needed;
      if(queue.status === STATUS_CLAIMED && queue.claimed_name === this.context.userInfo.name) {
        myClaimedMaterials[name] = (myClaimedMaterials[name] || 0) + queue.materials[name]
      }
      let present = Math.min(Math.max(inventory[name], 0) || 0, needed);
      let missing = needed - present;
      missingMaterials[name] = missing;
      if (missingMaterials[name] === 0) {
        delete missingMaterials[name];
      } else {
        ready = false;
      }
      inventory[name] -= present;
      inventory[name] -= missing;
    });

    if (!queue.status) {
      queue.status = STATUS_QUEUED
    }

    let isMine = queue.pilot === this.context.userData.name;

    let statusText = t('pages:queue.status.waitingForEngineer');
    let showClaim, showBuild, showDeliver, showComplete;
    let showCancel = this.context.roles.engineer || isMine;

    switch (queue.status) {
      case STATUS_QUEUED:
        showClaim = true;
        break;
      case STATUS_CLAIMED:
        showBuild = true;
        showDeliver = true;
        statusText = t('pages:queue.status.claimedBy', { name: queue.claimed_name });
        break;
      case STATUS_BUILT:
        showDeliver = true;
        showCancel = false;
        statusText = t('pages:queue.status.builtBy', { name: queue.claimed_name });
        break;
      case STATUS_DELIVERING:
        showComplete = true;
        showCancel = false;
        statusText = t('pages:queue.status.deliveringBy', { name: queue.claimed_name });
        break;
    }

    let isClaimedByMe = stripCorpTag(queue.claimed_name) === stripCorpTag(this.context.userData.name);
    if (!isClaimedByMe) {
      showBuild = false;
      showDeliver = false;
      showComplete = false;
    }

    let rowClass = "";
    if (isClaimedByMe) {
      rowClass = "table-success";
    } else if (queue.status == STATUS_QUEUED) {
      if(queue.location != "PAND-CZDJ") {
        rowClass = "table-warning";
      } else {
        rowClass = "table-info";
      }
    }


    // let showClaim = queue.status === STATUS_QUEUED;
    // let showBuild = queue.status === STATUS_CLAIMED;

    let buyerBalance = null;
    let buyerInfinite = false;
    if(queue.actorUserInfo) {
      let buyer = this.context.userMap[queue.actorUserInfo.id];
      buyerBalance = buyer.balanceIsk + buyer.balancePanda;
      if(buyer.roles && buyer.roles.superuser) {
        buyerInfinite = true;
      }
    }

    return <tr key={queue.id} className={rowClass}>
      <td>{renderShortDate(queue.timestamp)}</td>
      <td>{queue.location}</td>
      <td>
        {queue.name}
        <div className={"queue-notes"}>
          {queue.notes}
        </div>
      </td>
      <td>
        {stripCorpTag(queue.pilot)}
        {queue.actorUserInfo ?  <div className={"queue-notes"}>
          {buyerInfinite ? "∞" : numberWithCommas(buyerBalance)} ISK
        </div> : null}
      </td>
      <td>{numberWithCommas(queue.price)} ISK</td>
      <td>{statusText}</td>
      <td>
        {ready ? '-' : <Toggle>
          <ul>
            {Object.keys(missingMaterials).map(name => {
              return <li key={name}>{numberWithCommas(missingMaterials[name])} {name}</li>
            })}
          </ul>
        </Toggle>}
      </td>
      <td>
        <div className={"btn-group"}>
          {(this.context.roles.engineer && showClaim) ? <button className="btn btn-primary btn-sm" onClick={() => this.claim(queue)}>{t('pages:queue.actions.claim')}</button> : null}
          {/* {(this.context.roles.engineer && showBuild) ? <button className="btn btn-primary btn-sm" onClick={() => this.build(queue)}
                                                                disabled={!globalSettings.enableBuildAndDeliver}>{t('pages:queue.actions.build')}</button> : null} */}

          {(this.context.roles.engineer && showDeliver) ? <DropdownButton id="dropdown-basic-button" title={t('pages:queue.actions.deliver')} size={"sm"} variant={"primary"}>
            <Dropdown.Item onClick={() => this.deliver(queue, true)}>{t('pages:queue.actions.deliverAndBill')}</Dropdown.Item>
            <Dropdown.Item onClick={() => this.deliver(queue, false)}>{t('pages:queue.actions.deliverWithoutBilling')}</Dropdown.Item>
          </DropdownButton> : null}
          {/*{(this.context.userData.admin && showDeliver) ? <button className="btn btn-primary btn-sm" onClick={() => this.deliver(queue)} disabled={!globalSettings.enableBuildAndDeliver}>{t('pages:queue.actions.deliver')}</button> : null}*/}
          {(this.context.roles.engineer && showComplete) ?
              <button className="btn btn-primary btn-sm" onClick={() => this.complete(queue)}>{t('common:buttons.complete')}</button> : null}
          {(isMine || this.context.roles.engineer) ? <div className="btn-group"><DropdownButton title={t('common:buttons.edit')} size={"sm"} variant={"secondary"}>
                {this.context.roles.engineer ?
                    <div>
                      <Dropdown.Item onClick={() => this.toTop(queue)}>{t('pages:queue.actions.moveToTop')}</Dropdown.Item>
                      <Dropdown.Item onClick={() => this.toBottom(queue)}>{t('pages:queue.actions.moveToBottom')}</Dropdown.Item>
                      <Dropdown.Item onClick={() => this.toMain(queue)}>{t('pages:queue.actions.moveToMain')}</Dropdown.Item>
                      <Dropdown.Item onClick={() => this.toSpecial(queue)}>{t('pages:queue.actions.moveToSpecial')}</Dropdown.Item>
                      {showBuild ? <Dropdown.Item onClick={() => this.unclaim(queue)}>{t('pages:queue.actions.unclaim')}</Dropdown.Item> : null}
                      <Dropdown.Divider />
                    </div>
                : null}
                {(showCancel || this.context.roles.finance) ? <Dropdown.Item onClick={() => this.setNote(queue)}>{t('pages:queue.actions.setNote')}</Dropdown.Item> : null}
                {(this.context.roles.finance) ? <Dropdown.Item onClick={() => this.setPrice(queue)}>{t('pages:queue.actions.setPrice')}</Dropdown.Item> : null}
                <Dropdown.Divider />
                {(showCancel || this.context.roles.finance) ? <Dropdown.Item onClick={() => this.cancel(queue)}>{t('common:buttons.cancel')}</Dropdown.Item> : null}
              </DropdownButton></div> : null}
          {/*{showCancel ? <button className="btn btn-danger btn-sm" onClick={() => this.cancel(queue)}>Cancel</button> : null}*/}
          {/*{this.context.userData.admin ?*/}
          {/*  <span>*/}
          {/*  /!*&nbsp;*!/*/}
          {/*  /!*  <button className="btn btn-secondary btn-sm" onClick={() => this.toTop(queue)}>To top</button>*!/*/}
          {/*  &nbsp;</span>*/}
          {/*: null }*/}
          {/*      {?*/}
          {/*<span>*/}
          {/*  </span>*/}
          {/*: null }*/}
        </div>

      </td>
    </tr>
  };

  renderQueue(queue) {
    const { t } = this.props;

    return <div>
      <table className={"table table-striped"}>
        <thead>
        <tr>
          <th>{t('common:labels.date')}</th>
          <th>{t('common:labels.location')}</th>
          <th>{t('common:labels.name')}</th>
          <th>{t('common:labels.pilot')}</th>
          <th>{t('common:labels.price')}</th>
          <th>{t('common:labels.status')}</th>
          <th>{t('pages:queue.tableHeaders.materialsNeeded')}</th>
          <th>{t('common:labels.actions')}</th>
        </tr>
        </thead>
        <tbody>
        {queue}
        </tbody>
      </table>
    </div>
  }


  render() {
    if (!Object.keys(this.context.materialsMap).length) {
      return null;
    }

    let inventory = inventoryFromMaterialsMap(this.context.materialsMap, this.state.location);
    let initialInventory = Object.assign({}, inventory);
    let totalMaterials = {};
    let myClaimedMaterials = {};

    let mainQueue = this.context.queue.filter(item => item.queue === "main");
    let specialQueue = this.context.queue.filter(item => item.queue === "special");
    let permanentQueue = this.context.queue.filter(item => item.queue === "permanent");

    let renderedMainQueue = mainQueue.map((queue) => this.renderQueueRow(queue, inventory, 1.0, totalMaterials, myClaimedMaterials));
    let renderedSpecialQueue = specialQueue.map((queue) => this.renderQueueRow(queue, inventory, this.state.specialWeight / 100, totalMaterials, myClaimedMaterials));


    let renderedPermanentQueue = null;
    if (this.state.numPermanent > 0) {
      renderedPermanentQueue = permanentQueue.map((queue) => this.renderQueueRow(queue, inventory, this.state.numPermanent, totalMaterials, myClaimedMaterials));
    }

    // for(let i=0; i<this.state.numPermanent-1; i++) {
    //   permanentQueue.forEach((queue) => this.renderQueueRow(queue, inventory, 1.0))
    // }

    let totalShortfallValue = 0;
    Object.keys(inventory).forEach(name => {
      let amt = inventory[name];
      if (amt < 0) {
        totalShortfallValue += amt * this.context.materialsMap[name].price
      }
    });

    console.log(myClaimedMaterials);

    const { t } = this.props;

    return <div className={"container"}>

      <ul>
        <li>{t('pages:queue.instructions.checkMaterials')}</li>
        <li>{t('pages:queue.instructions.updateInventory')}</li>
        <li>{t('pages:queue.instructions.checksMinerals')}</li>
        <li>{t('pages:queue.instructions.buildSubtracts')}</li>
      </ul>

      <div className={"btn-tookbar mb-3"}>
        <div className={"input-group mr-2"}>
          <div className="input-group-prepend">
            <span className="input-group-text" id="">{t('common:labels.location')}</span>
          </div>
          <select className="form-control" value={this.state.location} onChange={e => this.setLocation(e)}>
            <option value="">{t('pages:queue.allBases')}</option>
            {globalSettings.allowShipOrdersAt.map((id) =>
                <option key={id} value={id}>{globalSettings.locations[id]}</option>
            )}
          </select>
        </div>
      </div>

      <Card>
        <Card.Header>
          <Nav variant="tabs">

            <Route exact path="/queue">
              <Redirect to="/queue/main"/>
            </Route>

            <Nav.Item>
              <LinkContainer to="/queue/main">
                <Nav.Link href="/queue/main">{t('pages:queue.tabs.main')}</Nav.Link>
              </LinkContainer>
            </Nav.Item>

            <Nav.Item>
              <LinkContainer to="/queue/special">
                <Nav.Link href="/queue/special">{t('pages:queue.tabs.special')}</Nav.Link>
              </LinkContainer>
            </Nav.Item>

            <Nav.Item>
              <LinkContainer to="/queue/permanent">
                <Nav.Link href="/queue/permanent">{t('pages:queue.tabs.permanent')}</Nav.Link>
              </LinkContainer>
            </Nav.Item>

            <If cond={Object.keys(myClaimedMaterials).length}><Nav.Item>
              <LinkContainer to="/queue/claimed">
                <Nav.Link href="/queue/claimed">{t('pages:queue.tabs.claimed')}</Nav.Link>
              </LinkContainer>
            </Nav.Item></If>

            <Nav.Item>
              <LinkContainer to="/queue/inventory">

                <Nav.Link href="/queue/inventory">{t('pages:queue.tabs.inventory')}</Nav.Link>
              </LinkContainer>

            </Nav.Item>
          </Nav>
        </Card.Header>

        <Switch>
          <Route path="/queue/main">
            {this.renderQueue(renderedMainQueue)}
          </Route>
          <Route path="/queue/special">
            {this.renderQueue(renderedSpecialQueue)}
          </Route>
          <Route path="/queue/permanent">
            {this.renderQueue(renderedPermanentQueue)}
          </Route>
          <Route path="/queue/claimed">
            <MaterialList materials={myClaimedMaterials} />
          </Route>
          <Route path="/queue/inventory">
            <ul>
              <li>{t('pages:queue.inventory.numPermanent')}: <input type={"number"}
                                                          value={this.state.numPermanent}
                                                          onChange={evt => this.setState({numPermanent: parseInt(evt.target.value)})}/>
              </li>
              <li>{t('pages:queue.inventory.specialWeight')}: <input type={"number"}
                                               value={this.state.specialWeight}
                                               onChange={evt => this.setState({specialWeight: parseInt(evt.target.value)})}/>
              </li>
              <li>
                {t('pages:queue.inventory.totalShortfall')}: {numberWithCommas(totalShortfallValue)} ISK
              </li>
              <FinanceOnly>
                <button className={"btn btn-primary mr-2"} onClick={() => this.updateRequests(totalMaterials)}>{t('pages:queue.inventory.updateTargetsUp')}</button>
                <button className={"btn btn-warning"} onClick={() => this.updateRequests(totalMaterials, true)}>{t('pages:queue.inventory.updateTargetsUpDown')}</button>
              </FinanceOnly>
            </ul>
            <table className="table table-bordered table-sm">
              <thead>
              <tr>
                <th>{t('common:labels.materials')}</th>
                <th>{t('common:labels.inventory')}</th>
                <th>{t('pages:queue.inventory.neededByQueue')}</th>
                <th>{t('pages:queue.inventory.buffer')}</th>
                <th>{t('pages:queue.inventory.currentRequest')}</th>
                <th>{t('pages:queue.inventory.extraShortfall')}</th>
                <th>{t('common:labels.price')}</th>
                <th>{t('pages:queue.inventory.extraShortfallValue')}</th>
              </tr>
              </thead>
              <tbody>
              {Object.keys(inventory).sort((a, b) => this.context.materialsMap[a].order - this.context.materialsMap[b].order).map(name => {
                let amt = inventory[name];
                if (!isNaN(amt) && amt !== 0) {
                  let className = amt < 0 ? "table-warning" : "";
                  return <tr key={name} className={className}>
                    <td>{name}</td>
                    <td>{numberWithCommas(initialInventory[name])}</td>
                    <td>{numberWithCommas(initialInventory[name] - amt)}</td>
                    <td>{numberWithCommas(this.context.materialsMap[name].totalBuffer || 0)}</td>
                    <td>{numberWithCommas(this.context.materialsMap[name].totalTargetInventory)}</td>
                    <td>{numberWithCommas(amt)}</td>
                    <td>{parseInt(this.context.materialsMap[name].price)} ISK</td>
                    <td>{numberWithCommas(amt * this.context.materialsMap[name].price)} ISK</td>
                  </tr>
                } else {
                  return null
                }

              })}
              </tbody>

            </table>
          </Route>
        </Switch>
      </Card>
    </div>
  }
}
QueuePage.contextType = GlobalInfo;

export default withTranslation(['pages', 'common'])(QueuePage);